<template>
    <div id="onboarding-de" class="wrapper tab-call">
        <header>
            <span class="new-headline-xlg text-centered">Sie wissen nicht, was Sie tun sollen oder haben eine Frage?</span>

            <p class="new-text-lg text-centered text-color-default">Hinterlassen Sie uns Ihre Telefonnummer und wir kontaktieren Sie zeitnah.</p>
        </header>

        <contact-call-form></contact-call-form>

        <div class="btn-group">
            <v-button href="/" label="Zurück zur Startseite" variant="secondary" full-width></v-button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                errors: {},
            }
        },

        mounted() {
        },

        watch: {
        },

        methods: {
            submit() {

            }
        }
    }
</script>